import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { NgbActiveModal } from 'modal/modal-ref';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AuthenticationService } from 'app/shivam/shared/auth/authentication.service';
import { AFTER_LOGIN_ACTION } from 'app/shivam/model/login-enum';
import { TermsModalComponent } from 'app/shivam/terms-modal/terms-modal.component';
import { PrivacyModalComponent } from 'app/shivam/privacy-modal/privacy-modal.component';
import { NgIf, NgSwitch, NgSwitchCase, NgSwitchDefault } from '@angular/common';
import { EmailVerificationComponent } from '../email-verification/email-verification.component';
import { LoginFormComponent } from '../login-form/login-form.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { WebAuthnService } from 'app/shivam/services/webauthn.service';

@Component({
  selector: 'app-login-modal',
  templateUrl: './login-modal.component.html',
  styleUrls: ['./login-modal.component.scss'],
  imports: [NgIf, NgSwitch, NgSwitchCase, EmailVerificationComponent, NgSwitchDefault, LoginFormComponent]
})
export class LoginModalComponent implements OnInit, OnDestroy {
  componentDestroySubject = new Subject();
  hasEnrolledBiometrics = false;
  enrolledUser: any = null;
  biometricLoading = false;
  biometricPromptError = '';
  TOGGLE_ACTIONS = {
    OTP: {
      title: 'Login / Sign Up', socioContent: 'Sign Up with Social Network',
      query: 'Have an account?', action: 'signing up,',
      otherAction: { text: 'Login', key: 'LOGIN' },
      isAfterSocioLogin: false
    },
    LOGIN: {
      title: 'Login / Sign Up', socioContent: 'Sign In with Social Network',
      query: 'New to here?', action: 'logging in,',
      otherAction: { text: 'Sign Up', key: 'OTP' },
      secondaryLogin: 'Username', isAfterSocioLogin: false
    },
    MOBILE_OTP: {
      title: 'Verify Your Mobile Number', socioContent: '',
      query: '', action: '',
      otherAction: { text: '', key: '' },
      isAfterSocioLogin: true
    },
    MOBILE_OTP_LOGIN: {
      title: 'Verify OTP', socioContent: '',
      query: '', action: '',
      otherAction: { text: '', key: '' },
      isAfterSocioLogin: true
    },
    OTP_ONLY: {
      title: 'Verify OTP', socioContent: '',
      query: '', action: '',
      otherAction: { text: '', key: '' },
      isAfterSocioLogin: true
    },
    EMAIL_VERIFICATION: {
      title: 'Verify Your Email', socioContent: 'Verify Your email with following',
      query: '', action: '', otherAction: { text: '', key: '' }, isAfterPhoneLogin: true
    },
    FORGOT_PASSWORD: {
      title: 'Forgot Password', socioContent: 'Sign In with Social Network'
    },
  }
  activeAction: 'OTP' | 'LOGIN' | 'FORGOT_PASSWORD' | AFTER_LOGIN_ACTION.MOBILE_OTP | AFTER_LOGIN_ACTION.EMAIL_VERIFICATION = 'LOGIN'
  mobileNumber: string;
  email: string;
  isEdit: boolean;
  constructor(private activeModal: NgbActiveModal,
    private authenticationService: AuthenticationService,
    private webAuthnService: WebAuthnService,
    private cdr: ChangeDetectorRef,
    public dialog: NgbModal) { }

  ngOnInit(): void {
    this.socialLoginListener();
    this.afterSocioLoginListener();
    this.checkBiometrics();
  }

  async checkBiometrics() {
    try {
      const supported = await this.webAuthnService.isSupported();
      if (supported && this.webAuthnService.isEnrolled()) {
        this.hasEnrolledBiometrics = true;
        this.enrolledUser = this.webAuthnService.getEnrolledUser();
      } else {
        this.hasEnrolledBiometrics = false;
        this.enrolledUser = null;
      }
    } catch {
      this.hasEnrolledBiometrics = false;
    }
    this.cdr.markForCheck();
  }

  async unlockWithBiometrics() {
    this.biometricLoading = true;
    this.biometricPromptError = '';
    this.cdr.markForCheck();

    try {
      const res = await this.webAuthnService.authenticateWithBiometrics();
      if (res.success && res.user) {
        localStorage.setItem('currentUser', JSON.stringify(res.user));
        if (res.token) {
          localStorage.setItem('token', res.token);
        }
        this.authenticationService.getCurrentuser();
        this.authenticationService.loginCompleted.next('SUCCESS');
        this.activeModal.close(res.user);
      } else {
        this.biometricPromptError = res.error || 'Biometric verification failed.';
      }
    } catch (err: any) {
      this.biometricPromptError = err?.message || 'Biometric authentication failed.';
    } finally {
      this.biometricLoading = false;
      this.cdr.markForCheck();
    }
  }

  dismiss() {
    if (!this.loading) {
      this.activeModal.dismiss();
      const currentUser = JSON.parse(localStorage.getItem('currentUser'));
      if (currentUser) {
        this.authenticationService.loginCompleted.next('SUCCESS')
      }

    }
  }
  signInAnonymously(): void {
    this.mobileNumber = '';
    this.authenticationService._signInAnonymously('pooja-booking');
  }


  get loading() {
    return this.authenticationService.loading;
  }
  signInWithSocial(providerName: string): void {
    this.mobileNumber = '';
    this.authenticationService.signInWithSocial(providerName, 'pooja-booking');
  }

  emailSkip() {
    this.authenticationService.loginCompleted.next('SUCCESS');
    this.activeModal.close();
  }
  socialLoginListener() {
    this.authenticationService.loginCompleted.pipe(takeUntil(this.componentDestroySubject)).subscribe((res) => {
      if (res === 'SUCCESS') {
        this.authenticationService.getCurrentuser();
        const user = JSON.parse(localStorage.getItem('currentUser') || 'null');
        this.activeModal.close(user);
      }
    });
  }
  get currentUser() {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    return !!currentUser;
  }
  afterSocioLoginListener() {
    this.authenticationService.afterSocioLogin.subscribe((action) => {
      switch (action) {
        case AFTER_LOGIN_ACTION.EMAIL_VERIFICATION:
          this.activeAction = AFTER_LOGIN_ACTION.EMAIL_VERIFICATION

          break;
        case AFTER_LOGIN_ACTION.MOBILE_OTP:
          this.activeAction = AFTER_LOGIN_ACTION.MOBILE_OTP
          break;
        case AFTER_LOGIN_ACTION.LOGIN_ONLY:
          break;
        case AFTER_LOGIN_ACTION.PAYMENT:
          // this.paymentService.payment();
          break;

      }
      console.log("action", action);

    });
  }
  otpSent(event: { action, mobileNumber: string, isEdit?: boolean }) {
    this.activeAction = event.action;
    this.mobileNumber = event.mobileNumber;
    this.isEdit = event.isEdit;
  }
  editmobileNumber() {

  }
  ngOnDestroy() {
    this.componentDestroySubject.next(true);
    this.componentDestroySubject.complete();
  }

  openTermsModal() {
    this.dismiss();
    const dialogRef = this.dialog.open(TermsModalComponent, {
      size: 'lg',              // 'sm', 'lg', 'xl'
      centered: true,          // vertically centered
      backdrop: 'static',      // prevent closing on outside click
      keyboard: false          // prevent closing on Esc key
    });
  }

  openPrivacyModal() {
    this.dismiss();
    const dialogRef = this.dialog.open(PrivacyModalComponent, {
      size: 'lg',
      centered: true,
      backdrop: 'static',
      keyboard: false
    });
  }
}
